import { useRoutes } from 'react-router-dom';
import { Route } from './config/Routes';
import "../src/style/style.scss"

function App() {
  const element = useRoutes(Route)
  return (
   <>
   {element}
   </>
  );
}

export default App;
